import Layers from "slotworks/graphics/layers/layers";

export function MoveLayerBehind(layer: Layers, targetLayer: Layers) {
    layer.container.parent.setChildIndex(layer.container, layer.container.parent.getChildIndex(targetLayer.container));
}